const IntMaxValue = 2147483647;
const AMSTopValue = 1e3;
export {
  AMSTopValue,
  IntMaxValue
};
//# sourceMappingURL=Common.constants.js.map
